import React, { useState, useEffect } from "react"
import styled from "styled-components"

import MetaData from "@/common/components/MetaData"
import ResetCSS from "@/common/assets/css/style"
import ResultCard from "@/containers/MoneyFortune/View/result/ResultCard"
import {
  ResultDate,
  GetAndShare
} from "@/containers/MoneyFortune/money-fortune-data/ResultData"

export default function Result() {
  const [resultPageData, setResultPageDate] = useState({})
  useEffect(() => {
    const resultfilter = ResultDate.filter(value => {
      return value.roleID === "DoKwon"
    })[0]

    setResultPageDate(resultfilter)
  }, [])

  return (
    <Wrapper>
      <MetaData
        title={`我的代表人物是 區塊鏈大割 - Do Kwon`}
        description="天資聰穎的你成就非凡，對於投資項目有極高的掌握度，並且能夠快速上手，獲利滿滿。然而，多傾聽別人的投資見解加以整合，不論市場起伏多劇烈，你都將是最後的贏家。"
        url={`https://www.kryptogo.com/money-fortune/DoKwon`}
        image="https://i.ibb.co/LvxTMBh/OG-Do-Kwon.webp"
      />
      <ResetCSS />
      <ResultCard
        key={resultPageData.roleID}
        name={resultPageData.name}
        AKA={resultPageData.AKA}
        chance={resultPageData.chance}
        saying={resultPageData.saying}
        summary={resultPageData.summary}
        analysis={resultPageData.analysis}
        investment={resultPageData.investment}
        befit={resultPageData.befit}
        img={resultPageData.img}
        type="share"
        GetAndShare={GetAndShare}
        API={GetAndShare.API}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  * {
    ::-webkit-scrollbar-thumb {
      background: #00fff0;
      border-radius: 5px;
    }
    ::-webkit-scrollbar {
      width: 2px;
      background-color: none;
    }
  }
`
